import { useHiikoEnvSlice } from 'app/containers/HiikoEnv/slice';
import { useResourceSlice } from 'app/containers/Resource/slice';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { useGlobalSlice } from '../../slice';
import { selectRedirectTo } from '../../slice/selectors';

interface IProps {
  children: React.ReactChild;
}

const GlobalWrapper = ({ children, ...props }: IProps) => {
  const { actions: globalActions } = useGlobalSlice();

  // Inject slices
  useHiikoEnvSlice();
  useResourceSlice();

  const dispatch = useDispatch();
  const redirectTo = useSelector(selectRedirectTo);

  const history = useHistory();

  // Redirect from redux
  useEffect(() => {
    if (redirectTo) {
      history.push(redirectTo);
      dispatch(globalActions.setRedirectTo(null));
    }
  }, [redirectTo, globalActions, dispatch, history]);

  return <> {children} </>;
};

export default GlobalWrapper;
